/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import Header from "./header"
import "./layout.scss"
import Scroller from "./scroller"
import Scrollspy from "react-scrollspy"
import { Nav } from "react-bootstrap"
import Popup from "../components/popup"

import ExitPopup from "../images/exit-popup.svg"

const getScrollNode = element => {
  return element.ownerDocument.scrollingElement || element.ownerDocument.documentElement
}

const isScrolled = element => {
  const scrollNode = getScrollNode(element)
  return scrollNode.scrollTop > 0
}

export default class Layout extends React.Component {
  constructor(props) {
    super(props)
    this.siteContainer = React.createRef()
    this.state = {
      scrolled: false,
    }
    this.handleScroll = this.handleScroll.bind(this)
    Scroller.handleAnchorScroll = Scroller.handleAnchorScroll.bind(this)
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll)
    const element = this.siteContainer.current
    this.setState({
      scrolled: isScrolled(element),
    })
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll)
  }

  handleScroll() {
    const element = this.siteContainer.current
    this.setState({
      scrolled: isScrolled(element),
    })
  }

  handleChildClick(e) {
    e.stopPropagation()
  }

  render() {
    let className = "site-container"
    if (this.props.className) className += ` ${this.props.className}`
    if (this.state.scrolled) className += " navbar-scrolled"
    const { popupSuccess, isLeaveAnimation } = this.props
    if (popupSuccess) className += " is-blurred"
    return (
      <>
        {popupSuccess && (
          <div className="confirmation-popup" onClick={this.props.closePopup}>
            <div className={`confirmation-popup__inner ${isLeaveAnimation ? "confirmation-popup__inner--hidePopup" : ""}`} onClick={this.handleChildClick}>
              <div className="confirmation-popup__content">
                <h2>
                  Twoje zapytanie zostało <br /> do nas wysłane
                </h2>
                <h6>Odpowiemy najszybciej jak to możliwe</h6>
                <img src={ExitPopup} alt="Sukces!" />
                <div className="confirmation-popup__buttons">
                  <button className={`btn btn-accept my-3`} onClick={this.props.closePopup}>
                    Zamknij
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
        {this.props.activeItem !== "" && <Popup isLeaveAnimation={isLeaveAnimation} closePopup={this.props.closePopup} activeItem={this.props.activeItem} />}
        <div className={className} ref={this.siteContainer} id="page-top">
          <Header />
          <main>{this.props.children}</main>
          <footer className="py-4">
            <div className="container">
              <a className="navbar-brand js-scroll-trigger" href="#page-top" onClick={Scroller.handleAnchorScroll}></a>

              <Scrollspy className="navbar-nav" items={["about", "offer", "portfolio", "contact"]} currentClassName="active" rootEl={"#mainNav"} offset={-75}>
                <li className="nav-item">
                  <Nav.Link className={"js-scroll-trigger"} href="#about" onClick={Scroller.handleAnchorScroll}>
                    Usługi
                  </Nav.Link>
                </li>
                <li className="nav-item">
                  <Nav.Link className={"js-scroll-trigger"} href="#offer" onClick={Scroller.handleAnchorScroll}>
                    Oferta
                  </Nav.Link>
                </li>
                <li className="nav-item">
                  <Nav.Link className={"js-scroll-trigger"} href="#portfolio" onClick={Scroller.handleAnchorScroll}>
                    Ralizacje
                  </Nav.Link>
                </li>
                <li className="nav-item">
                  <Nav.Link className={"js-scroll-trigger"} href="#contact" onClick={Scroller.handleAnchorScroll}>
                    Kontakt
                  </Nav.Link>
                </li>
              </Scrollspy>
            </div>
            <div className="author">
              Twórca{" "}
              <a href="https://www.behance.net/ewalipka" target="_blank" rel="noopener noreferrer">
                Ewa Lipka
              </a>
            </div>
          </footer>
        </div>
      </>
    )
  }
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
}
